module.exports = __webpack_public_path__ + "img/環境監測.b377a614.svg";